import { Link } from "react-router-dom";
import { MapPin, Gift } from "lucide-react";
import { motion } from "framer-motion";
import { mediaUrl } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { CountdownTimer } from "@/components/CountdownTimer";

export const ItemCard = ({ item, index = 0 }) => {
  const img = item.images?.[0];
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.4) }}
    >
      <Link to={`/item/${item.id}`} data-testid={`item-card-${item.id}`}
        className="group block rounded-2xl bg-card border border-border/60 tactile-shadow overflow-hidden hover:-translate-y-1 transition-transform">
        <div className="aspect-[4/3] bg-secondary overflow-hidden relative">
          {img ? (
            <img src={mediaUrl(img)} alt={item.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
          ) : (
            <div className="h-full w-full flex flex-col items-center justify-center gap-2 bg-primary/5 text-primary/50">
              <Gift className="h-9 w-9" />
              <span className="text-xs font-semibold uppercase tracking-widest">{item.category}</span>
            </div>
          )}
          <Badge className="absolute top-3 left-3 bg-white/90 text-foreground hover:bg-white border-0 font-medium">{item.category}</Badge>
          {item.status === "reserved" && <Badge className="absolute top-3 right-3 bg-accent text-white border-0">Prenotato</Badge>}
          {item.expires_at && item.status === "approved" && <CountdownTimer expiresAt={item.expires_at} className="absolute bottom-3 left-3 shadow-sm" />}
        </div>
        <div className="p-4">
          <h3 className="font-head font-bold text-lg leading-tight line-clamp-1">{item.title}</h3>
          <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{item.description}</p>
          <div className="flex items-center gap-1 mt-3 text-xs text-muted-foreground">
            <MapPin className="h-3.5 w-3.5" /> {item.city}{item.province ? ` (${item.province})` : ""}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ItemCard;
